import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { UncontrolledAlert } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// import TextField from 'material-ui/TextField';
// import Checkbox from 'material-ui/Checkbox';
import { CircularProgress } from 'material-ui/Progress';
import Button from 'material-ui/Button';
import { FormControl, FormControlLabel } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
// import Input, { InputLabel } from 'material-ui/Input';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import ContainerHeader from '../../../components/ContainerHeader/index';

import * as addMail from '../../../actions/maildetails';
import Switch from 'material-ui/Switch';
import * as regData from '../../../../appConstants'
class AddMail extends Component {

    constructor(props) {
        super(props);
        this.state = {
            id: this.props.params.id,           
            port:'',
            host:'',
            user_name:'',
            pass:'',
            ssl:false,
            sentfrom:'',
            isSet:false            
        };
        // console.log('this.state.customer', this.state.customer);
    }

    handleChange = name => event => {
        if (name == 'ssl') 
            {        
                this.setState({ [name]: event.target.checked });                
            }
            else
            {
                this.setState({ [name]: event.target.value });
            }
      
    };

    handleSave = event => {
        event.preventDefault();
        // console.log("name", this.state.name)
        if (this.state.id) {
            // console.log('this.state.id', this.state.id)
            // this.props.actions.fetchTeamDetails(this.state.id);
            this.props.actions.addMailDetails({"id":this.state.id, "port": this.state.port,"host": this.state.host,"user_name": this.state.user_name,
            "pass": this.state.pass,"ssl": this.state.ssl,"sentfrom": this.state.sentfrom });
        } 
    };

    componentDidMount() {
        // console.log('componentDidMount', this.state.id)
       
        if (this.state.id) {
            // console.log('this.state.id', this.state.id)
            this.props.actions.fetchMailDetails(this.state.id);
        }
        else
            this.props.actions.resetMail();
    }

    render() {
        const { mailDetails } = this.props;
        // console.log('mailDetails',mailDetails)
        let result = null;
        console.log("test", mailDetails);
        if (mailDetails && mailDetails.Status) {
            result = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        else if (mailDetails && mailDetails.maildetails && mailDetails.apiGetResult && !this.state.isSet) {         
            this.state.port=mailDetails.maildetails.port;
            this.state.host=mailDetails.maildetails.host;
            this.state.user_name=mailDetails.maildetails.user_name;
            this.state.pass='';
            this.state.ssl= mailDetails.maildetails.ssl==1?true:false;
            this.state.sentfrom=mailDetails.maildetails.sentfrom;  
            this.state.isSet = true;
        }
        else if (mailDetails && mailDetails.apiPostResult)
            this.props.history.push('mail-list');
            
        return (
            <div className="slideInUpTiny ">
            {result}
                <ContainerHeader title="Update Mail Configuration" match={JSON.parse('{"path":"/mail/mail-update","url":"/mail/mail-update","isExact":true,"params":{}}')} />
                <div className="row mb-md-4">
                    <div className="col-12">
                        <div className="jr-card">                          
                            <div className="slideInUpTiny ">
                                <ValidatorForm className="row" autoComplete="off" onSubmit={this.handleSave}>
                                    <TextValidator margin="normal" fullWidth
                                        name="host" label="Host" placeholder="Host"
                                        validators={['required',regData.getCustomExpression(':/.'),regData.getCustomExpressionLength(':/.',0,100)]} 
                                        errorMessages={['This field is required',regData.getCustomExpMessage(':/.'),regData.messageLength]} 
                                        value={this.state.host} onChange={this.handleChange('host')}
                                    />
                                        <TextValidator margin="normal" fullWidth
                                        name="port" label="Port" placeholder="Port"
                                        validators={['required', 'isNumber']}
                                        errorMessages={['This field is required','number is not valid']}
                                        value={this.state.port} onChange={this.handleChange('port')}
                                    />
                                        <TextValidator margin="normal" fullWidth
                                        name="user_name" label="User Name" placeholder="User Name"
                                        validators={['required',regData.getCustomExpression('@.'),regData.getCustomExpressionLength('@.',0,100)]}
                                        errorMessages={['This field is required',regData.getCustomExpMessage('@.'),regData.messageLength]}
                                        value={this.state.user_name} onChange={this.handleChange('user_name')}
                                    />
                                        <TextValidator margin="normal" fullWidth
                                        name="sentfrom" label="Sent From" placeholder="Sent From"
                                        validators={['required',regData.getCustomExpression('@.<>" '),regData.getCustomExpressionLength('@.<>" ',0,100)]}
                                        errorMessages={['This field is required',regData.getCustomExpMessage('@.<>"'),regData.messageLength]}
                                        value={this.state.sentfrom} onChange={this.handleChange('sentfrom')}
                                    />
                                      <TextValidator margin="normal" fullWidth
                                        name="pass" label="PASS" placeholder="PASS"
                                        validators={['required']}
                                        errorMessages={['This field is required']}
                                        value={this.state.pass} onChange={this.handleChange('pass')}
                                    />
                                    <br/>
                                        <FormControlLabel control={<Switch classes={{ checked: 'text-primary', bar: 'bg-primary', }}
                                                checked={this.state.ssl} onChange={this.handleChange('ssl')} />
                                            } label="SSL" />                            
                                 
                                  <br/>
                                    <Button type="submit" variant="raised" color="primary">
                                        Save
                                        </Button>
                                </ValidatorForm>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    console.log("state==>",state)
    const { mailDetails } = state
    console.log("updatemail",state)
    return { mailDetails, params: ownProps.match.params }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(addMail, dispatch)
    };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddMail));



// WEBPACK FOOTER //
// ./app/maildetails/addmail/index.js